export const ProductActionTypes = {
  GET_PRODUCT: "GET_PRODUCT",
  ADD_PRODUCT: "ADD_PRODUCT",
  RESET_PRODUCTS: "RESET_PRODUCTS",
  GET_PRODUCT_START: "GET_PRODUCT_START",

  START_OFFER: "START_OFFER",
  END_OFFER: "END_OFFER",
};
